import "./Css/window.css";
import "./Css/PlaylistSelector.css";
import "./Css/app.css";
import "./Css/snack.css";

import { ModalWindow, Root } from '@tblabs/truffle';
import { PlayerPage } from './Pages/PlayerPage';

ModalWindow.Hook = Root.Hook;
ModalWindow.DefaultCssClasses = "tf-modal-window";

const root = new Root();

root.Append(new PlayerPage());
